import { Component, OnInit, Input, AfterViewChecked, HostListener, ViewChild, ElementRef } from '@angular/core';
import { environment } from '../../../environments/environment';
import { EventService } from '../../services/event/event.service';
import { HelperService } from '../../services/helper/helper.service';

declare var $;

import swal from 'sweetalert2';

@Component({
  selector: 'app-uploaded-file-view',
  templateUrl: './uploaded-file-view.component.html',
  styleUrls: ['./uploaded-file-view.component.css']
})
export class UploadedFileViewComponent implements OnInit, AfterViewChecked {

  @ViewChild('toggleCommentBtn') public toggleCommentBtn: ElementRef;

  private _file = null;
  @Input()
  set file(value) {
    const data = value.data || value;
    console.log(value, data);
    this._file = {
      ...value,
      extension: value.extension || value.type,
      title: this.type === 'link' || !!value.url
        ? data.name
        : data.title || value.name.split('.').slice(0, -1).join('.'),
      comment: data.comment || '',
      order: data.order || 0,
    };
  }

  get file() {
    return this._file;
  }

  get linkUrl() {
    return this.helper.getLinkUrl(this._file);
  }

  @Input() type = 'doc';
  @Input() customStyle = {};
  @Input() hideComment = false;

  public commentVisible = false;

  constructor(
    public event: EventService,
    public helper: HelperService
  ) { }

  @HostListener('window:click', ['$event'])
  onWindowClick(event) {
    const commentPopover = event.path.find(elem => {
      return elem && elem.classList && elem.classList.contains('comment-popover')
        || (this.toggleCommentBtn && elem === this.toggleCommentBtn.nativeElement);
    });
    if (!commentPopover) {
      this.commentVisible = false;
    }
  }

  get title() {
    if (this._file) {
      return this._file.title || this._file.name;
      // // return name.length > 9
      // //   ? name.substr(0, 7) + '...'
      // //   : name;
      // return name;
    }
    return '';
  }

  ngOnInit() {
    // console.log(this.file)
  }

  ngAfterViewChecked() {
    $('[data-toggle="tooltip"]').tooltip();
  }

  getDownloadablePath(file) {
    if (!file.path && !file.tmp_path) {
      return environment.basePath + '/' + file.enc_name;
    } else {
      const filename = '/' + file.enc_name + '.' + file.extension;
      const filepath = file.tmp_path ? file.tmp_path + filename : file.path + filename;
      return environment.basePath + '/' + filepath;
    }
  }

  toggleComment(event) {
    this.commentVisible = !this.commentVisible;
  }

  showComment() {
    const title = this.file.title || this.file.name;
    swal({
      title,
      html: this.file.comment,
      customClass: 'swal-font-md'
    });
  }

}



// WEBPACK FOOTER //
// G:/UTL/Student/Student-ANG/src/app/shared/uploaded-file-view/uploaded-file-view.component.ts